import { Component, ViewChild, Inject, Pipe, PipeTransform, EventEmitter, OnDestroy } from '@angular/core';
import {FormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {from, of} from 'rxjs';
import {debounceTime, mergeMap, catchError, concatMap} from 'rxjs/operators';

import * as Airtable from 'airtable';

import {ApiService} from '../shared/api.service';
import {AssignmentsService} from '../shared/assignments.service';
import {Assignment} from '../assignments/assignment.model';
import {TeamService} from '../shared/team.service';
import { Slide } from '../slideshow/slide/slide.model';
import {Utils} from '../utils';

@Pipe({name: 'paginate'})
export class PaginatePipe implements PipeTransform {
    transform(values, paginator, quiz, intro) {
        let pageSize = paginator.pageSize;
        let pageIndex = paginator.pageIndex;
        let begin = (pageIndex * pageSize);
        if( pageIndex === 0 ) {
            begin = 0;
        } else if ( quiz || intro ) {
            begin += 1;
        }
        let end = (begin + pageSize);
        if( quiz || !intro || (!quiz && intro && pageIndex > 0) ) {
            end -= 1;
        }
        let filtered = values.filter((item, index) => {
            return index >= begin && index <= end;
        });
        return filtered;
    }
}
@Component({
    selector: 'import-component',
    templateUrl: 'import.component.html'
})
export class ImportComponent implements OnDestroy {
    assignment;
    columns = ['site', 'abbr', 'title', 'slug', 'date', 'actions'];
    comments = [];
    controlAbbr = new FormControl();
    controlTitle = new FormControl();
    controlSelectAll = new FormControl();
    controlSite = new FormControl();
    properties = [];
    results = [];
    slides = [];
    title = '';
    abbr = '';
    page = 1;
    pageSize = 0;
    found = 0;
    paginator = {
        pageIndex: 0,
        pageSize: 10,
        length: this.slides.length
    }
    currentPageIndex = 0;
    slideCount = 0;
    importInProgress = false;
    importMessages = [];
    slideImportStarted = false;
    importSuccess;
    selected = [];
    selectedColumns = ['remove', 'site', 'abbr', 'title', 'slug', 'date', 'primary'];
    airtableEvent = new EventEmitter();
    airtable = new Airtable({apiKey: 'keyj06MxfOTxj2MWG'}).base('appRDMMCYkTt8I6Sv');
    connectMode = false;
    teamService = new TeamService();
    importSearchAbbr = this.utils.rand();
    importSearchTitle = this.utils.rand();
    importAssignmentTitle = this.utils.rand();
    importAssignmentAbbr = this.utils.rand();
    importAssignmentArticleTitle = this.utils.rand();
    importAssignmentTeaser = this.utils.rand();
    subscriptions = [];

    @ViewChild('stepper') stepper;
    @ViewChild('paginator1') paginator1;
    @ViewChild('paginator2') paginator2;
    @ViewChild('paginator3') paginator3;
    @ViewChild('selectedTable') selectedTable;

    constructor(
        private api: ApiService, 
        private assignments: AssignmentsService,
        public dialog: MatDialog,
        private route: ActivatedRoute, 
        private router: Router,
        public utils: Utils
    ) {
            let properties = this.api.getProp('sites');
            this.properties = properties;
            
            const abbrsubscription = this.controlAbbr.valueChanges.pipe(debounceTime(400)).subscribe(
                value => {
                    this.abbr = value;
                    this.page = 1;
                    if( this.paginator3 ) {
                        this.paginator3.firstPage(); 
                    }
                    if( this.connectMode === true ) {                    
                        this.getAssignments();
                        return;
                    }
                    this.search();
                }
            );
            const titlesbuscription = this.controlTitle.valueChanges.pipe(debounceTime(400)).subscribe(
                value => {
                    this.title = value;
                    this.page = 1;
                    if( this.paginator3 ) {
                        this.paginator3.firstPage(); 
                    }
                    if( this.connectMode === true ) {                    
                        this.getAssignments();
                        return;
                    }
                    this.search();        
                }
            );
            let doCheck = true;
            const sitesubscription = this.controlSite.valueChanges.pipe(debounceTime(400)).subscribe(
                value => {
                    if( value ) {
                        let selectAll = value.length == this.properties.length ? true : false;
                        doCheck = false;
                        this.controlSelectAll.setValue(selectAll);
                        doCheck = true;
                    }
                    this.page = 1;
                    if( this.paginator3 ) {
                        this.paginator3.firstPage(); 
                    }
                    if( this.connectMode === true ) {                    
                        this.getAssignments();
                        return;
                    }
                    this.search();
                }
            );
            const selectsubscription = this.controlSelectAll.valueChanges.subscribe(
                checked => {
                    if( checked !== null && doCheck ) {
                        let value = checked ? this.properties : [];
                        this.controlSite.setValue(value);
                    }
                }
            );
            this.subscriptions = [
                abbrsubscription,
                titlesbuscription,
                sitesubscription,
                selectsubscription
            ];
    }
    ngAfterViewInit() {
        this.controlSelectAll.setValue(true);
    }
    addComment(comments) {
        this.comments = comments;
    }
    addComments(id) {
        let comments = this.comments;
        let len = this.comments.length;
        for(var i = 0; i < len; i++) {
            let comment = comments[i];
            comment.post = id;
            this.api.doAction('post', 'comment', {
                action: 'create',
                comment: comment
            }).subscribe();
        }
    }
    addMessage(message, error) {
        this.importMessages.push({
            error: error,
            text: message
        });
    }
    cancel() {
        this.assignment = null;
        this.slides = [];
        this.currentPageIndex = 0;
        this.paginator = {
            pageIndex: 0,
            pageSize: 10,
            length: this.slides.length
        };
        this.slideCount = 0;
        this.importMessages = [];
    }
    getContentPlaceholder(slide, index) {
        let quiz = this.assignment.quiz;
        let placeholder = 'What\'s the buzz?';
        if( (index > 0 && !quiz) || (quiz && quiz.intro) ) {
            placeholder = 'bzzz bzzz...';
        }
        if( quiz && !slide.intro && !slide.outro ) {
            placeholder = 'Answer';
        }
        if( quiz && slide.outro ) {
            placeholder = 'Result Summary';
        }
        return placeholder;
    }
    getSiteTriggerText() {
        let text = '';
        let value = this.controlSite.value;
        if( value ) {
            text = value.map(site => site.domain).join(', ');
        }
        return text;
    }
    removePost(i, item) {
        if( item.primary && this.selected.length > 1 ) {
            this.selected[0].primary = true;
        }
        this.selected.splice(i, 1);
        this.selectedTable.renderRows();
    }
    addPost(post, selectedForImport) {
        let selected = this.selected;
        let found = selected.filter(item => post.ID == item.ID);
        if( found.length === 0 ) {
            this.selected.push(post);
            this.primaryChange({checked:true}, post);
            selectedForImport.scrollIntoView();
        }
    }
    getAssignment() {
        this.api.doAction('post', 'import', {
            step: 'get_assignment',
            data: this.selected
        }).subscribe(
            data => {
                this.selected = [];
                this.assignment = new Assignment(data);
                this.teamService.loadTeam(this.assignment);
            },
            err => {
                let message = 'An unknown server error occured.';
                if( err.error && err.error.hasOwnProperty('message') ) {
                    message = err.error.message;
                }
                let dialog = this.dialog.open(ErrorDialog, {
                    data: {
                        message: message
                    }
                });
                console.log('Error getting article.', err);
            }
        );
    }
    getPageNumber(i) {
        i = i + (this.currentPageIndex * 10);
        let pageNumber = i + 1;
        if( !this.assignment.quiz && this.slides[0].intro && pageNumber > 1 && this.currentPageIndex < 1 ) {
            pageNumber = pageNumber - 1;
        }
        return pageNumber;
    }
    getSlides(stepper, step) {
        step.completed = true;
        if( this.slides.length > 0 ) {
            stepper.next();
            return;
        }
        
        this.api.doAction('post', 'import', {
            step: 'get_slides',
            data: this.assignment
        }).subscribe(
            data => {
                this.slides = data.map((item, index) => {
                    item.index = index;
                    return new Slide(item);
                });
                let len = this.slides.length;
                let intro = len > 0 ? this.slides[0].intro : false;
                this.slideCount = intro ? len - 1 : len;
                this.assignment.intro = intro;
                stepper.next();
            },
            err => {
                console.log('Error imporing article.', err);
                let message = 'An unknown server error occured.';
                if( err.error && err.error.hasOwnProperty('message') ) {
                    message = err.error.message;
                }
                let dialog = this.dialog.open(ErrorDialog, {
                    data: {
                        message: message
                    }
                });
            }
        );
    }
    import(step) {
        this.importInProgress = true;
        this.stepper.next();
        
        this.importAssignment(this.assignment).pipe(
                concatMap(response => this.importSlides(response)) // request won't continue until importAssignment successfully completes
            )
            .subscribe(
                data => {
                    let error = false;
                    if( data ) {
                        const index = data.index;
                        let slide = this.slides[index];
                        slide = Object.assign(slide, data);
                    } else {
                        error = true;
                    }
                    this.updateMessage(data.message, error);
                },
                (err, data) => {
                    this.importInProgress = false;
                    this.importSuccess = false;
                    this.importMessages = [];
                    console.log('Error importing slide.', err, data);
                    if( err.error && err.error.hasOwnProperty('data') ) {
                        this.updateMessage(err.error.data.message, true);
                    } else {
                        let dialog = this.dialog.open(ErrorDialog, {
                            data: {
                                message: 'An unknown server error occured. Import will continue.'
                            }
                        });
                    }
                },
                () => {
                    this.importInProgress = false;
                    step.completed = true;
                    let assignment = this.assignment;
                    if( assignment.id ) {
                        assignment.slides = this.slides
                                            .filter(item => item.id ? true : false)
                                            .map(item => item.id)
                                            .join(',');
                        this.saveSlides(assignment);
                        this.assignments.add(assignment);
                        this.cancel();
                        this.importSuccess = true;
                        this.updateAirtable(assignment.id, assignment.sites);
                    } else {
                        this.importSuccess = false;
                        this.importMessages = [];
                    }
                    console.log('import complete');
                }
            );
    }
    saveSlides(assignment) {
        this.api.doAction('post', 'meta', {
            id: assignment.id,
            action: 'update',
            fields: [
                {
                    name: 'slides',
                    value: assignment.slides
                }
            ]
        }).subscribe();
    }
    getAirtableRecords(sites) {
        let searches = [];
        for( var i = 0; i < sites.length; i++ ) {
            let link = sites[i].permalink.replace('http://', '').replace('https://', '');
            searches.push('SEARCH("'+link+'", {Link})');
        }
        let search = 'OR(' + searches.join(', ') + ')';
        this.airtable('Quiz and Slideshow List').select({
            filterByFormula: search
        }).firstPage((err, records) => {
            this.airtableEvent.emit({
                error: err,
                records: records,
                complete: false
            });
        });
    }
    updateAirtableRecords(records, id) {
        let link = this.api.getProp('url') + '/slideshow/' + id;
        let last = records.length - 1;
        for(var i = 0; i < records.length; i++) {
            let recordId = records[i].id;
            this.airtable('Quiz and Slideshow List').update(recordId, {
                "SWARM Link": link
            }, function(err, record) {
                if(err) { 
                    console.error('Error updating airtable.', err); 
                    return; 
                }
            });
            if( i == last ) {
                this.airtableEvent.emit({
                    records: records,
                    error: false,
                    complete: true
                });
            }
        }
    }
    updateAirtable(id, sites) {
        this.airtableEvent.subscribe(data => {
            if( data.complete && sites.length === data.records.length ) {
                //navigate
                this.router.navigate(['slideshow', id]);
                return;
            }
            if( data.error || data.records.length == 0 || sites.length !== data.records.length ) {
                console.log('Error updating airtable.', data);
                //popup
                let dialog = this.dialog.open(ErrorDialog, {
                    data: {
                        message: 'There was an error updating Airtable. Please update manually.'
                    }
                });
                dialog.afterClosed().subscribe(data => {
                    this.router.navigate(['slideshow', id]);
                });
                return;
            }
            this.updateAirtableRecords(data.records, id);
        });
        this.getAirtableRecords(sites);
    }
    updateMessage(themessage, error) {
        let messages = this.importMessages;
        let text = 'done!';
        if( error ) {
            text = 'error! This was not imported.'
        }
        for(var i = 0; i < messages.length; i++) {
            let message = messages[i].text;
            if( message == themessage ) {
                messages[i].text += text;
            }
        }
    }
    importAssignment(assignment) {
        let createAssignmentMessage = 'Creating assignment: ' + assignment.title + ' ...';
        this.addMessage(createAssignmentMessage, false);
        assignment.index = 0;
        assignment.message = createAssignmentMessage;
        return this.api.doAction('post', 'import', {
            step: 'import_post',
            data: assignment
        });
    }
    importSlide(slide, index, author) {
        let slideMessage = 'Creating slide ' + (index + 1) + ' ...';
        this.addMessage(slideMessage, false);
        slide.index = index;
        slide.message = slideMessage;
        slide.author = author;
        slide.assignmentId = this.assignment.id;
        return this.api.doAction('post', 'import', {
            step: 'import_post',
            data: slide
        });
    }
    importSlides(data) {
        if( !data.id ) {
            this.importSuccess = false;
            this.importMessages = [];
            return; // short circuit importAssignment
        }
        let assignment = this.assignment;
        assignment = Object.assign(assignment, data);
        this.updateMessage(assignment.message, false);
        this.addComments(assignment.id);
        let author = this.api.getProp('currentUserId');
        if( assignment.team.length > 0 ) {
            author = assignment.team[0].id;
        }
        return from(this.slides).pipe(
            mergeMap( // performs all requests in parallel
                (slide, index) => from(this.importSlide(slide, index, author)).pipe(
                    catchError(error => of(error)) // allows error handling per request
                )
            )
        );
    }
    pageChange(event) {
        this.page = event.pageIndex + 1;
        if( this.connectMode === true ) {                    
            this.getAssignments();
            return;
        }
        this.search();
    }
    readyToImport(stepper, step) {
        step.completed = true;
        stepper.next();
    }
    search() {
        let params = {
            title: this.title,
            abbr: this.abbr,
            page: this.page,
            per_page: 15,
            sites: this.controlSite.value
        };
        this.api.doAction('post', 'search', params).subscribe(
            data => {
                this.results = data;
                this.pageSize = data.length;
                this.found = this.api.foundPosts;
            }
        );
    }
    slidePageChange(e, scroll) {
        this.paginator = e;
        let currIndex = e.pageIndex;
        this.currentPageIndex = currIndex;
        this.paginator1.pageIndex = currIndex;
        this.paginator2.pageIndex = currIndex;
        if( scroll ) {
            window.scroll(0,0);
        }
    }
    addItem(item) {
        item.primary = false;
        let selected = this.selected;
        if( selected.length == 0 ) {
            item.primary = true;
        }
        let found = selected.filter(option => item.ID == option.ID);
        if( found.length == 0 ) {
            this.selected.push(item);
        }
    }
    removeItem(item) {
        let selected = this.selected;
        let len = selected.length
        for( var i = 0; i < len; i++) {
            let option = selected[i];
            if( option.ID == item.ID ) {
                this.selected.splice(i, 1);
                if( option.primary && this.selected.length > 0 ) {
                    this.selected[0].primary = true;
                }
                break;
            }
        }
    }
    selectedChange(event, item) {
        if( event.checked ) {
            this.addItem(item);
        } else {
            this.removeItem(item);
        }
        if( this.selectedTable ) {
            this.selectedTable.renderRows();
        }
    }
    primaryChange(event, item) {
        if( !event.checked ) {
            this.selected[0].primary = true;
            return;
        }
        this.selected = this.selected.map(option => {
            if( item.ID != option.ID ) {
                option.primary = false;
            } else {
                option.primary = true;
            }
            return option;
        });

        if( this.selectedTable ) {
            this.selectedTable.renderRows();
        }
    }
    getAssignments() {
        let filters = [];
        const abbr = this.abbr;
        const title = this.title;
        const sites = this.controlSite.value;
        if( abbr ) {
            filters.push({
                key: 'abbreviation',
                value: abbr,
                compare: 'LIKE'
            });
        }
        if( title ) {
            filters.push({
                key: 'title',
                value: title,
                compare: 'LIKE'
            });
        }
        if( sites.length > 0 ) {
            const blog_ids = [];
            for(var i = 0; i < sites.length; i++) {
                blog_ids.push(sites[i].blog_id);
            }
            
            filters.push({
                key: 'sites',
                value: blog_ids.join('|'),
                compare: 'LIKE'
            });
        }
        let query = {
            per_page: 15,
            context: 'edit',
            page: this.page
        };
        if( filters.length ) {
            query['filters'] = filters;
            query['relation'] = 'AND';
        }
        this.api.doAction('post', 'assignments', {
            action: 'read',
            query: query,
            timestamp: new Date().valueOf()
        }).subscribe(data => {
            this.results = data.posts.map(item => {
                item.swarm_id = item.id;
                return item;
            });
            this.pageSize = data.posts.length;
            this.found = this.api.foundPosts;
        });
    }
    enterConnectMode() {
        this.connectMode = true;
        this.page = 1;
        if( this.paginator3 ) {
            this.paginator3.firstPage(); 
        }
        this.getAssignments();
    }
    exitConnectMode() {
        this.connectMode = false;
        this.removePrimary();
        this.page = 1;
        if( this.paginator3 ) {
            this.paginator3.firstPage(); 
        }
        this.search();
    }
    removePrimary() {
        let i = this.selected.length;
        while(i--) {
            const item = this.selected[i];
            if( item.swarm_id ) {
                this.selected.splice(i, 1);
            }
            item.primary = false;
        }
        if( this.selected.length > 0 ) {
            this.selected[0].primary = true;
        }
        this.selectedTable.renderRows();
    }
    setPrimary(item) {
        let i = this.selected.length;
        while(i--) {
            const selectedItem = this.selected[i];
            if( selectedItem.swarm_id ) {
                this.selected.splice(i, 1);
            }
            selectedItem.primary = false;
        }
        item.primary = true;
        this.selected.unshift(item);
        this.selectedTable.renderRows();
    }
    maybeNavigate(e, item) {
        e.preventDefault();
        if( this.connectMode === false ) {
            this.router.navigate(['/slideshow', item.swarm_id]);
            return;
        }
        this.setPrimary(item);
    }
    connect() {
        const selected = this.selected;
        if( selected.length < 2 ) {
            return;
        }
        if( !selected[0].swarm_id ) {
            return;
        }
        this.api.doAction('post', 'import', {
            step: 'connect',
            data: this.selected
        }).subscribe(
            data => {
                this.assignments.assignments = this.assignments.assignments.map(item => {
                    if( item.id == data.id ) {
                        item.sites = data.sites;
                    }
                    return item;
                });
                this.selected = [];
                this.connectMode = false;
                this.page = 1;
                if( this.paginator3 ) {
                    this.paginator3.firstPage(); 
                }
                this.search();
            }
        )
    }
    ngOnDestroy() {
        this.connectMode = false;
        const subscriptions = this.subscriptions;
        for(var i = 0; i < subscriptions.length; i++) {
            subscriptions[i].unsubscribe();
        }
    }
}
@Component({
    selector: 'error-dialog',
    template: `
        <h2 mat-dialog-title>Import Error</h2>
        <mat-dialog-content [innerHtml]="data.message"></mat-dialog-content>
        <mat-dialog-actions>
            <button class="button faded" [mat-dialog-close]="false">OK</button>
        </mat-dialog-actions>`,
})
export class ErrorDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
